<template>
  <div id="accountAssociated">
    <div style="height: 55px;background-color: #fff;"></div>
    <div class="content">
      <div class="top">
        <img :src="icon" alt="">
        <p class="tips">关联账号</p>
      </div>
      <div class="account">
        <div :class="select === 1 ? 'active' : ''" @click="select = 1">已有账号</div>
        <div :class="select === 2 ? 'active' : ''" @click="select = 2">未有账号</div>
      </div>
      <div v-if="select === 1">
        <div class="dr container">
          <input type="tel" maxlength="11" v-model="userPhone" placeholder="请输入手机号码"
                 onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))">
        </div>
        <div class="dr container">
          <input v-model="passWord" type="password" placeholder="请输入密码" @keyup.enter="submit()"/>
        </div>
        <div class="btn" @click="submit()">绑定账号</div>
      </div>
      <div v-if="select === 2">
        <div class="dr container">
          <input type="tel" maxlength="11" v-model="userPhone" placeholder="请输入手机号码"
                 onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))">
        </div>
        <div class="dr randCode container">
          <input v-model="randCode" type="number" placeholder="请输入验证码" @keyup.enter="submit()">
          <send-btn class="sendBtn" :user-phone="userPhone" rand-type="BBS_BINDWX "></send-btn>
        </div>
        <div class="dr container">
          <input v-model="passWord" type="password" placeholder="请输入密码"/>
        </div>
        <div class="btn" @click="registered()">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from '../../common/js/types'
import loading from '../common/loading.vue'
import sendBtn from '../common/sendBtn.vue'
export default {
  name: 'accountAssociated',
  components: {
    loading,
    sendBtn
  },
  data () {
    return {
      isLoad: true,
      icon: require('../../assets/icon/logo.png'),
      select: 1,
      userPhone: '',
      passWord: '',
      randCode: '',
      unionId: ''
    }
  },
  methods: {
    submit () {
      let that = this
      that.axios.post('/bindWx', {
        userPhone: that.userPhone,
        passWord: that.passWord,
        unionId: that.unionId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit(types.LOGIN, response.data.value)
          that.$store.commit('setToastMsg', '绑定成功')
          that.axios.post('/cart/list', {
            userId: that.$root.getUserId()
          }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            emulateJSON: true// 需要转json
          }).then(function (response) {
            if (response.data.status === 0) {
              // console.log(response.data.value)
              // response.data.value.forEach((item) => {
              //   item.num = obj[item.cartId]
              //   if (item.num === 'undefined') {
              //     that.clear(item.cartId)
              //   }
              //   that.checked.push(false)
              // })
              // that.goodsList = response.data.value
              localStorage.setItem('c', response.data.value.length)
            } else {
              that.$store.commit('setToastMsg', response.data.msg)
            }
          }).catch(function (response) {
            that.$store.commit('setToastMsg', '网络错误')
          })
          that.$router.push('/')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    registered () {
      let that = this
      that.axios.post('/bindWx', {
        userPhone: that.userPhone,
        randCode: that.randCode,
        passWord: that.passWord,
        unionId: that.unionId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit(types.LOGIN, response.data.value)
          that.$store.commit('setToastMsg', '绑定成功')
          that.axios.post('/cart/list', {
            userId: that.$root.getUserId()
          }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            emulateJSON: true// 需要转json
          }).then(function (response) {
            if (response.data.status === 0) {
              // console.log(response.data.value)
              // response.data.value.forEach((item) => {
              //   item.num = obj[item.cartId]
              //   if (item.num === 'undefined') {
              //     that.clear(item.cartId)
              //   }
              //   that.checked.push(false)
              // })
              // that.goodsList = response.data.value
              localStorage.setItem('c', response.data.value.length)
            } else {
              that.$store.commit('setToastMsg', response.data.msg)
            }
          }).catch(function (response) {
            that.$store.commit('setToastMsg', '网络错误')
          })
          that.$router.push('/')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    getToken () {
      let that = this
      let code = this.$route.query.code
      that.axios.post('../api/wx/auth', {
        wxCode: code,
        wxType: 'B'
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          console.log(response.data.value)
          that.unionId = response.data.value.unionid
          that.axios.post('/userInfo', {
            unionId: response.data.value.unionid
          }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            emulateJSON: true
          }).then(function (response) {
            if (response.data.status === 0) {
              that.$store.commit(types.LOGIN, response.data.value)
              that.$store.commit('setToastMsg', '登录成功')
              that.$router.push('/')
            } else {
              that.$router.push('/accountAssociated')
            }
          }).catch(function (response) {
            that.$store.commit('setToastMsg', '网络错误')
          })
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  created () {
  },
  mounted () {
    if (this.$route.query.code) {
      this.getToken()
    }
  }
}
</script>

<style scoped>
  #accountAssociated{
    height: 100%;
    background-color: #fbfbfb;
  }
  .content{
    width: 300px;
    margin: 100px auto;
  }
  .tips {
    font-size: 20px;
    margin: 15px 0;
  }
  .account{
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }
  .account div{
    width: 150px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    border-bottom: 2px solid #fbfbfb;
  }
  .account div.active{
    color: #06B570;
    border-bottom: 2px solid #06B570;
  }
  .dr {
    width: 300px;
    margin-bottom: 17px;
  }
  .dr input{
    height: 40px;
    width: 100%;
    outline: 0;
    font-size: 14px;
    text-indent: 1em;
    border: 1px solid #F0F0F0;
  }
  .randCode input{
    width: 200px !important;
    float: left;
  }
  .btn{
    width: 300px;
    height: 46px;
    line-height: 46px;
    color: white;
    cursor: pointer;
    background-color: #06B570;
  }
</style>
<style>
  .sendBtn{
    margin: 0 !important;
    padding: 0;
    width: 90px !important;
    height: 41px !important;
    line-height: 41px !important;
    font-size: 14px !important;
    float: right !important;
    color: #05B570;
    background-color: #ffffff;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/accountAssociated.vue